import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from '@app/services/title.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SuccessStoryService } from '../../../services/success-story.service';
import { Observable, map, tap, withLatestFrom } from 'rxjs';
import { SuccessStoriesState, SuccessStory } from '@app/store/stories/reducer';
import { Store } from '@ngrx/store';
import { getSuccessStories } from '@app/store/stories/actions';
import {
  selectIsLoadingStoriesSuccessStory,
  selectIsLoadingSuccessStory,
  selectPages,
  selectSuccessStoriesData,
} from '@app/store/stories/selector';
import { SingleProjectsContent } from './success-story-model';
@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories-page.component.html',
  styleUrls: ['./success-stories-page.component.scss'],
})
export class SuccessStoriesPageComponent implements OnInit {
  disableScrollDown = false;
  page = 1;

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 6,
    items: 5,
    lazyLoad: true,
    navSpeed: 600,
    navText: ['Prev', 'Next'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 3,
      },
      760: {
        items: 5,
      },
      1000: {
        items: 5,
      },
    },
    nav: true,
  };
  totalPages: number;
  stories$: Observable<Partial<SuccessStory>[]>;
  isLoading$: Observable<boolean>;
  singleProjectsBox: SingleProjectsContent[];
  sentLastPageRequest: boolean;
  isLoadingStories$: Observable<boolean>;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const triggerAt: number = 512;
    if (
      document.body.scrollHeight <=
        window.innerHeight + window.scrollY + triggerAt &&
      !this.sentLastPageRequest
    ) {
      if (this.page + 1 <= this.totalPages) {
        this.page += 1;
        this.store.dispatch(
          getSuccessStories({ page: this.page, pageSize: 18 })
        );
        this.sentLastPageRequest = true;
      }
    }
  }

  constructor(
    private titleService: TitleService,
    public successStoryApiService: SuccessStoryService,
    private store: Store<{ successStoriesState: SuccessStoriesState }>,
    private router: Router
  ) {
    this.stories$ = this.store.select(selectSuccessStoriesData).pipe(
      withLatestFrom(this.store.select(selectPages)),
      map(([stories, totalPages]) => {
        this.totalPages = totalPages;
        return stories;
      })
    );
    this.isLoadingStories$ = this.store
      .select(selectIsLoadingStoriesSuccessStory)
      .pipe(
        tap(isLoading => {
          if (!isLoading && this.sentLastPageRequest) {
            this.sentLastPageRequest = false;
          }
        })
      );
    this.store.dispatch(getSuccessStories({ page: this.page, pageSize: 18 }));
  }

  ngOnInit(): void {
    this.isLoading$ = this.store.select(selectIsLoadingSuccessStory);
    this.singleProjectsBox = [
      {
        icon: 'bx bx-plus',
        img: 'assets/img/projects/Global-wells.jpg',
        imgClass: '',
        title: 'Global Well List',
        subTitle:
          'Created a global list of wells with well operating status, company code, ownership, and other standard well header metadata that is automatically generated and maintained that is easily curated and validated to make the well list authoritative/trusted.',
        link: '/success-stories-details/globalwells',
      },
      {
        icon: 'bx bx-plus',
        img: 'assets/img/projects/iScout-KPA(Cover Pic).png',
        imgClass: '',
        title: 'PNG iScout/KPA - Preventing Equipment Failure',
        subTitle:
          'Collected and analyzed screening information of 700+ small bore connections to help identify potential areas prone to fatigue failure.',
        link: '/success-stories-details/iscout-kpa',
      },
      {
        icon: 'bx bx-plus',
        img: 'assets/img/projects/WellView-Timelog-Gold-Table.png',
        imgClass: '',
        title: 'WellView Timelog Gold Table',
        subTitle:
          'Provided engineers and subject matter experts with an easily searchable, consolidated view into all of our nearly 10 million Timelog entries for well construction activities.',
        link: '/success-stories-details/goldtable',
      },
    ];
    this.titleService.setTitle('Success Stories');
  }

  public trackItem(_: number, item: any) {
    return item.id;
  }

  btnClick = function () {
    this.router.navigate(['/add-success-story-page']);
  };
  redirect(id: string) {
    this.router.navigate(['/success-stories/' + id]);
  }

  randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  randomImage() {
    return `assets/img/blog/img${this.randomInteger(1, 12)}.jpg`;
  }

  onImageError($event: any) {
    $event.target.src = this.randomImage();
  }
}
